





























































































































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {$, ID, success} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import {UploadConfig} from '@/config/upload.config'
import {FileFormat} from '@/enums/FileFormat'
import {DeliveryStatus} from '@/enums/DeliveryStatus'
import ModalShare from '@/components/modals/ModalShare.vue'
import ModalUpload from '@/components/modals/ModalUpload.vue'
import Carga from '@/model/resource/Carga'
import * as Helper from '@/helpers'
import ItAudit from '@/components/itrack/ItAudit.vue'
import { cloneDeep } from 'lodash'
import DeliveryPhotoSection from '@/views/get/DeliveryPhotoSection.vue'

const metaInfo = () => ({
  title: $.t('view.get.deliveryGet.title'),
})

@Component({
  metaInfo,
  components: {DeliveryPhotoSection, ModalShare, ModalUpload},
})
export default class DeliveryGetView extends Vue {
  @Prop({type: [String, Number]}) id?: ID
  @Prop({type: String, default: null}) hash!: string | null

  AppConfig = AppConfig
  UploadConfig = UploadConfig
  FileFormat = FileFormat
  DeliveryStatus = DeliveryStatus

  carga = new Carga() as Carga

  get guestMode() {
    return !!(this.id && this.hash)
  }

  async uploadIt() {
    const audit = this.$refs.audit as ItAudit
    // @ts-ignore
    audit.loadInfo()
  }

  get status() {
    if (this.carga.statusCarga) {
      return this.carga.statusCarga.$id as DeliveryStatus
    }
    return null
  }
  async mounted() {
    await this.refresh()

    await Helper.sleep(1000)

    if (this.$route.query.print === '1') {
      this.openPrint()
    }
  }
  openPrint() {
    window.print()
  }

  openShare() {
    $.modal.open('share')
  }

  async refresh(spinner?: string) {
    if (this.guestMode) {
      const hash = this.hash ? encodeURIComponent(this.hash) : null
      const carga = await this.carga.findByQuery({id: this.id, hash})
      return carga
    }

    if (this.id) {
      await this.carga.find(this.id, spinner)
    }

    if (this.carga.cargaConcreto) {
      this.carga.cargaConcreto.usina = this.carga.sigla
    }

    $.await.done('findCarga')
  }
}
